var _rect, _text, _text2, _text3, _text4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _text5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase2Fig2CatchesToChecks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 660",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 660,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Each catch beside the check that found it")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Six catches across five checks. The expensive checks are the ones that pay.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 100,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "SIX CATCHES")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 740,
    y: 100,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "FIVE CHECKS")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 110,
    width: 470,
    height: 66,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 137,
    fontSize: 13.5
  }, /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontWeight: 700,
    fill: "#1A2F2A"
  }, "D-002"), /*#__PURE__*/React.createElement("tspan", {
    dx: 8,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "money-transmission exemption")), /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 158,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "an external regulatory claim, read fresh at the live source"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 188,
    width: 470,
    height: 66,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 215,
    fontSize: 13.5
  }, /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontWeight: 700,
    fill: "#1A2F2A"
  }, "D-007"), /*#__PURE__*/React.createElement("tspan", {
    dx: 8,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "sybil cost floor")), /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 236,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "the \"non-bootstrappable\" floor priced at about $80 on the open web"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 266,
    width: 470,
    height: 66,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 293,
    fontSize: 13.5
  }, /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontWeight: 700,
    fill: "#1A2F2A"
  }, "D-015"), /*#__PURE__*/React.createElement("tspan", {
    dx: 8,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "FinCEN control and missing concurrency control")), /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 314,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "a claimed control absent from the code, plus a gap the draft missed"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 344,
    width: 470,
    height: 66,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 371,
    fontSize: 13.5
  }, /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontWeight: 700,
    fill: "#1A2F2A"
  }, "D-011"), /*#__PURE__*/React.createElement("tspan", {
    dx: 6,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "against"), /*#__PURE__*/React.createElement("tspan", {
    dx: 6,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontWeight: 700,
    fill: "#1A2F2A"
  }, "D-008"), /*#__PURE__*/React.createElement("tspan", {
    dx: 8,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "sibling contradiction")), /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 392,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "two recent locks that could not both hold as written"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 422,
    width: 470,
    height: 66,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 449,
    fontSize: 13.5
  }, /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontWeight: 700,
    fill: "#1A2F2A"
  }, "D-006"), /*#__PURE__*/React.createElement("tspan", {
    dx: 8,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "over-read steer")), /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 470,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "a steer applied stronger than the words that gave it"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 500,
    width: 470,
    height: 66,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 527,
    fontSize: 13.5
  }, /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontWeight: 700,
    fill: "#1A2F2A"
  }, "D-021"), /*#__PURE__*/React.createElement("tspan", {
    dx: 8,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "gate components")), /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 548,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "the gate's parts checked against what the pipeline actually ran"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 740,
    y: 124,
    width: 412,
    height: 66,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 756,
    y: 151,
    fontSize: 13.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Web-verify external claims"), /*#__PURE__*/React.createElement("text", {
    x: 756,
    y: 172,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "open the cited source and read it fresh"), /*#__PURE__*/React.createElement("text", {
    x: 1136,
    y: 151,
    fontSize: 11,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontWeight: 700,
    fill: "#16A34A",
    textAnchor: "end"
  }, "2 catches"))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 740,
    y: 214,
    width: 412,
    height: 66,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 756,
    y: 241,
    fontSize: 13.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Re-derive measured numbers"), /*#__PURE__*/React.createElement("text", {
    x: 756,
    y: 262,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "recompute every quoted figure from raw inputs"), /*#__PURE__*/React.createElement("text", {
    x: 1136,
    y: 241,
    fontSize: 11,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontWeight: 700,
    fill: "#16A34A",
    textAnchor: "end"
  }, "1 earlier catch"))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 740,
    y: 304,
    width: 412,
    height: 66,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 756,
    y: 331,
    fontSize: 13.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Code-verify against the repository"), /*#__PURE__*/React.createElement("text", {
    x: 756,
    y: 352,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "read the code the draft claims to describe"), /*#__PURE__*/React.createElement("text", {
    x: 1136,
    y: 331,
    fontSize: 11,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontWeight: 700,
    fill: "#16A34A",
    textAnchor: "end"
  }, "2 catches"))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 740,
    y: 394,
    width: 412,
    height: 66,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 756,
    y: 421,
    fontSize: 13.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Scan recent sibling locks"), /*#__PURE__*/React.createElement("text", {
    x: 756,
    y: 442,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "read the neighboring ledger entries for conflicts"), /*#__PURE__*/React.createElement("text", {
    x: 1136,
    y: 421,
    fontSize: 11,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontWeight: 700,
    fill: "#16A34A",
    textAnchor: "end"
  }, "1 catch"))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 740,
    y: 484,
    width: 412,
    height: 66,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 756,
    y: 511,
    fontSize: 13.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Fold steers in literally"), /*#__PURE__*/React.createElement("text", {
    x: 756,
    y: 532,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "quote each steer and apply only its words"), /*#__PURE__*/React.createElement("text", {
    x: 1136,
    y: 511,
    fontSize: 11,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontWeight: 700,
    fill: "#16A34A",
    textAnchor: "end"
  }, "1 catch"))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    stroke: "#D4DDD6",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M518 143 C 600 143, 655 157, 734 157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518 221 C 600 221, 655 168, 734 168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518 299 C 600 299, 655 330, 734 330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518 377 C 600 377, 655 427, 734 427"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518 455 C 600 455, 655 517, 734 517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518 533 C 620 533, 640 344, 734 344"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "#D4DDD6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M732 151 l9 6 l-9 6 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 162 l9 6 l-9 6 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 324 l9 6 l-9 6 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 421 l9 6 l-9 6 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 511 l9 6 l-9 6 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 338 l9 6 l-9 6 z"
  }))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 622,
    fontSize: 13.5,
    fontWeight: 500,
    fill: "#1A2F2A"
  }, "Four of the six catches came from the two costliest checks: reading the cited source fresh, and reading the repository itself. Each paid twice.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase2Fig2CatchesToChecks);
export default __webpack_public_path__ + "static/media/case2-fig2-catches-to-checks.e316ee0395d11bb773af15e1037e0052.svg";
export { ForwardRef as ReactComponent };